import {useContext} from 'react'

import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import Context from '@s-ui/react-context'
import MoleculeNotification, {
  moleculeNotificationAlignItems,
  moleculeNotificationBorderSizes,
  moleculeNotificationPosition,
  moleculeNotificationTypes,
  moleculeNotificationVariations
} from '@s-ui/react-molecule-notification'

const NoIcon = () => null

const NotificationSortManagement = ({onClose = () => {}}) => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const {SORT_MANAGEMENT_TERMS_PATH_PATTERN} = config.get('page')

  return (
    <div className="mt-NotificationSortManagement">
      <MoleculeNotification
        alignItems={moleculeNotificationAlignItems.FLEX_START}
        autoClose={false}
        icon={<NoIcon />}
        onClose={onClose}
        position={moleculeNotificationPosition.relative}
        roundedCorners={moleculeNotificationBorderSizes.medium}
        type={moleculeNotificationTypes.system}
        variation={moleculeNotificationVariations.positive}
      >
        <div className="mt-NotificationSortManagement-content" data-nosnippet>
          <p className="mt-NotificationSortManagement-contentText">
            {htmlStringToReactElement(
              i18n.t('NOTIFICATIONS.SORT_MANAGEMENT_NOTIFICATION.TEXT', {
                linkStart: `<a href="${SORT_MANAGEMENT_TERMS_PATH_PATTERN}" class='mt-NotificationSortManagement-contentLink' target="_blank">`,
                linkEnd: '</a>'
              })
            )}
          </p>
        </div>
      </MoleculeNotification>
    </div>
  )
}

NotificationSortManagement.displayName = 'NotificationSortManagement'
NotificationSortManagement.propTypes = {
  onClose: PropTypes.func
}

export default NotificationSortManagement
